import { Component, OnInit } from '@angular/core';
import { eInvitation } from '@app/signup/steps/shared/steps.model';

@Component({
  selector: 'error-own',
  templateUrl: './own.component.html',
  styleUrls: ['./own.component.scss', '../signup-errors.component.scss'],
})
export class ErrorOwnComponent implements OnInit {
  managerUrl = '';
  eInvitation = eInvitation;
  state = window['CURRENT_STATE'];
  invitation = window['INVITATION'];
  endpoints = window['ENDPOINTS'];

  constructor() {}

  ngOnInit() {
    this.managerUrl = window['ENDPOINTS']?.manager || 'https://manager.infomaniak.com';
  }
}
